@if (column?.format === formats.DOWNLOAD) {
  <icon
    [id]="'action-' + rowIndex + dataGridId"
    name="download"
    [attr.title]="'download'"
    [config]="{ type: 'link' }"
    (click)="onActionClicked(row, 'download', $event)"
    [dataLoadEvent]="digitalDataGridService.getDataLoadDownloadEvent(column)"
    role="button"
    aria-label="Download"
  >
  </icon>
}
@if (column?.format === formats.ICON) {
  @if (getFormattedValue(row, column); as value) {
    <p [innerHTML]="value"></p>
  }
  <icon
    [id]="'actionIcon-' + column.action + rowIndex + dataGridId"
    [name]="column.icon"
    [attr.title]="column.action"
    [config]="{ type: 'link' }"
    (click)="onActionClicked(row, column.action, $event)"
    (keydown.space)="onActionClicked(row, column.action, $event)"
    tabindex="0"
    [dataLoadEvent]="digitalDataGridService.getDataLoadDownloadEvent(column)"
    [attr.aria-label]="column.label"
  >
  </icon>
}
@if (column?.format === formats.ICON_ONLY && row[column?.prop]) {
  <icon
    [id]="'actionIcon-' + column.action + rowIndex + dataGridId"
    [name]="column.icon"
    [label]="column.label"
    [attr.title]="column.action"
    [config]="{ type: 'link' }"
    (click)="onActionClicked(row, column.action, $event)"
    tabindex="0"
    [dataLoadEvent]="digitalDataGridService.getDataLoadDownloadEvent(column)"
    (keydown.space)="onActionClicked(row, column.action, $event)"
    [attr.aria-label]="column.label"
  >
  </icon>
}
@if (column?.format === formats.ACTION_ICONS) {
  <div class="DatagridCellOptions__actions">
    @for (
      actionIcon of column.actionIcons;
      track actionIcon;
      let index = $index
    ) {
      @if (
        !actionIcon.conditions || (row | zipConditional: actionIcon.conditions)
      ) {
        <icon
          [name]="actionIcon.icon"
          [id]="'actionIcon-' + actionIcon.action + index"
          [attr.title]="actionIcon.action"
          [config]="{ type: 'link' }"
          (click)="onActionClicked(row, actionIcon.action, $event)"
          (keydown.space)="onActionClicked(row, actionIcon.action, $event)"
          [dataLoadEvent]="
            digitalDataGridService.getDataLoadDownloadEvent(column)
          "
          tabindex="0"
        >
        </icon>
      }
    }
  </div>
}
@if (
  getTypeOf(getFormattedValue(row, column)) === 'object' &&
  column?.format === formats.PROGRESS_BAR
) {
  <div class="DatagridCellOptions__actions">
    @if (column?.format === 'TEXTWITHICON') {
      <lib-notes-text-with-icon
        [data]="row[column?.prop]"
      ></lib-notes-text-with-icon>
    }
  </div>
}
@if (column?.format === formats.DATE_RANGE) {
  <p tabindex="0" class="ui-description">
    <span
      [innerHTML]="
        getFormattedValue(row, { format: formats.DATE, prop: column.startProp })
      "
    ></span>
    <span>&nbsp;-&nbsp;</span>
    <span
      [innerHTML]="
        getFormattedValue(row, { format: formats.DATE, prop: column.endProp })
      "
    ></span>
  </p>
}
@if (column?.format === formats.BUTTON) {
  @if (row.is_cancelable && row.payment_status !== 'Canceled') {
    <zip-button
      [config]="config.button"
      (zipButtonClicked)="onActionClicked(row, 'cancel_payment', $event)"
    >
    </zip-button>
  }
}
@if (getFormattedValue(row, column); as value) {
  @switch (column?.format) {
    @case (formats.STATUS) {
      <status
        class="DatagridCellOptions__status u-flex"
        [ngClass]="{
          'DatagridCellOptions__status--RightAligned': column.isRightAligned,
        }"
        [config]="{
          hideBackground: config.hideStatusBackground,
          label: getStatusLabel(column, row[column?.prop]),
          statuses: column.statuses,
        }"
        data-test-id="DatagridCellOptionsColumnStatus"
      ></status>
    }
    @case (formats.LINK) {
      <a
        tabindex="0"
        class="t-link DatagridCellOptions__link"
        (click)="viewDetail(row, column?.prop, column?.routeToProp)"
        (keydown.enter)="viewDetail(row, column?.prop, column?.routeToProp)"
        role="link"
        href="javascript:void(0)"
        [innerHTML]="value"
      >
      </a>
    }
    @case (formats.SSO_LINK) {
      <a
        tabindex="0"
        class="t-link"
        (click)="viewSSODetail(row, column.route, column.options)"
        (keydown.enter)="viewSSODetail(row, column.route, column.options)"
        role="link"
        href="javascript:void(0)"
        [innerHTML]="column.ssoLinkLabel"
      >
        <icon
          class="DatagridCellOptions__SsoIcon"
          [config]="{ type: 'link', size: 'small' }"
          name="open_in_new"
          [attr.title]="'attachment'"
        >
        </icon>
      </a>
    }
    @case (formats.LIST) {
      <div>
        @for (line of row[column?.prop]; track line) {
          <p tabindex="0" class="ui-description" [innerHTML]="line"></p>
        }
      </div>
    }
    @case (formats.ATTACHMENT) {
      <icon name="attachment" [attr.title]="'attachment'"> </icon>
    }
    @case (formats.TEXT) {
      <p
        tabindex="0"
        class="ui-description"
        [ngClass]="{ 'is-unread': row.is_read === false }"
        [innerHTML]="value || '—'"
      ></p>
    }
    @case (formats.BOOLEAN_ICON) {
      <icon
        [name]="value"
        [config]="{ fill: value === 'check' ? 'success' : 'error' }"
      ></icon>
    }
    @case (formats.PROGRESS_BAR) {
      <zipari-progress-bar [data]="value"></zipari-progress-bar>
    }
    @case (formats.EXPANDING_LIST) {
      <expanding-list
        [list]="value"
        [config]="{ lineCount: column.limit || limit }"
      ></expanding-list>
    }
    @default {
      @if (
        column?.format !== formats.ICON_ONLY &&
        column?.format !== formats.ACTION_ICONS &&
        value.format !== 'TEXT_WITH_TOOLTIP'
      ) {
        <p
          tabindex="0"
          class="ui-description"
          [ngClass]="{
            't-bold':
              row.is_read === false || column?.format === formats.HEADER,
            'is-unread': row.is_read === false,
          }"
          [innerHTML]="value || '-'"
        ></p>
      }
    }
  }
  @if (value.format === 'TEXT_WITH_TOOLTIP') {
    @if (column?.format !== 'TEXTWITHICON') {
      <p
        tabindex="0"
        class="ui-description DatagridCellOptions__Description"
        [ngClass]="{ 'is-unread': row.is_read === false }"
        [ngStyle]="{ color: value.color }"
        [innerHTML]="
          getFormattedObjectValue(value.value, column, value.type) || '—'
        "
      ></p>
    }
    @if (value.tooltip) {
      <tooltip
        class="DatagridCellOptions__TooltipWithText"
        [config]="getFormattedTooltipObjectValue(value, column)"
      ></tooltip>
    }
  }
}
@if (isClickable(row, condition)) {
  <p
    (click)="onActionClicked(row, column.action, $event)"
    class="t-link"
    [innerHTML]="column.link || ''"
  ></p>
}
